export default __webpack_public_path__ + "67f41aa9b35c53127365773007d46691.pdf";